(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-sunfeather.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-sunfeather.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  Fragment = _React.Fragment;
setGlobal('svs.tickets.play.components.TicketSunfeather', _ref => {
  let accessibleText = _ref.accessibleText,
    children = _ref.children,
    onHandleNumberChanged = _ref.onHandleNumberChanged,
    handleGamePay = _ref.handleGamePay;
  const _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    hoverTicketNumber = _useState2[0],
    setHoverTicketNumber = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeFocus = _useState4[0],
    setActiveFocus = _useState4[1];
  const onMouseLeave = useCallback(() => {
    setHoverTicketNumber(-1);
  }, []);
  const onBlur = useCallback(() => setActiveFocus(null), []);
  const getHoverState = useCallback(number => {
    switch (number - hoverTicketNumber) {
      case -1:
        return -1;
      case 1:
        return 1;
      case 0:
        return 0;
      default:
        return undefined;
    }
  }, [hoverTicketNumber]);
  return React.createElement("div", {
    className: "sunfeather-container",
    "data-testid": "sunfeather-container"
  }, React.createElement("div", {
    className: "sunfeather-inner-container relative"
  }, React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      handleGamePay();
    }
  }, React.createElement("fieldset", null, React.createElement("legend", {
    className: "ticket-sunfeather-legend"
  }, accessibleText), React.Children.map(children, child => {
    const _child$props = child.props,
      number = _child$props.number,
      chosen = _child$props.chosen;
    const onChange = useCallback(() => onHandleNumberChanged(number), [number]);
    const onFocus = useCallback(() => setActiveFocus(number), [number]);
    return React.createElement(Fragment, null, React.createElement("input", {
      "aria-label": "Lott ".concat(number, " av ").concat(children.length),
      checked: chosen,
      className: "qa-ticket-sunfeather-radio hide-radio absolute",
      "data-testid": "ticket-sunfeather-radio-".concat(number),
      name: "ticket-skin-radio",
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      type: "radio",
      value: number
    }), React.createElement("label", {
      className: "sunfeather-item-wrapper"
    }, React.cloneElement(child, {
      onMouseEnter: setHoverTicketNumber,
      onMouseLeave,
      hoverState: getHoverState(number),
      hasFocus: activeFocus === number
    })));
  })), React.createElement("input", {
    className: "qa-ticket-sunfeather-input",
    name: "submit-button",
    style: {
      opacity: 0,
      width: 0,
      height: 0
    },
    tabIndex: "-1",
    type: "submit"
  }), React.createElement("div", {
    className: "sunfeather-height-wrapper"
  }, children[0]))));
});

 })(window);